module.exports = __webpack_public_path__ + "img/header_4.2add3338.png";